<template>
    <div class="filter_block">
        <div class="form-group js-stools-container-filters mb-4">
            <div class="d-flex flex-wrap ">
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select v-else
                              class="imc_reasons"
                              label="name"
                              placeholder=" Оберіть Організацію"
                              id="id"
                              v-model="filter.org_id"
                              @input="emit_filter"
                              :reduce="item => item.id"
                              :options="organizations"
                              :filterable="true"
                    
                    >
                        <template slot="no-options">
                            Оберіть Організацію
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                                <small>{{ option.edrpou }}</small>
                            </div>
                        </template>
                    </v-select>
                </div>
                
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select
                        v-else
                        class="imc_reasons"
                        label="name"
                        id="id"
                        @input="emit_filter"
                        v-model="filter.user_id"
                        :reduce="item => item.id"
                        :options="users"
                        :filterable="true"
                        placeholder="Оберіть Користувача"
                    >
                        <template slot="no-options">
                            Оберіть Користувача
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                </div>
                
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select
                        v-else
                        class="imc_reasons"
                        label="name"
                        id="name"
                        @input="emit_filter"
                        v-model="filter.trip_from_id"
                        :options="trips_from"
                        :filterable="true"
                        placeholder="Звідки"
                    >
                        <template slot="no-options">
                            Оберіть Напрямок
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                </div>
                
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select
                        v-else
                        class="imc_reasons"
                        label="name"
                        id="name"
                        @input="emit_filter"
                        v-model="filter.trip_to_id"
                        :options="trips_to"
                        :filterable="true"
                        placeholder="-- Куди -- "
                    >
                        <template slot="no-options">
                            Оберіть Напрямок
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option }}
                            </div>
                        </template>
                    </v-select>
                </div>
                
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select v-else
                              class="imc_reasons"
                              label="title"
                              placeholder="Оберіть Транспорт"
                              id="id"
                              v-model="filter.car_id"
                              @input="emit_filter"
                              :reduce="item => item.id"
                              :options="cars"
                              :filterable="true"
                    
                    >
                        <template slot="no-options">
                            Оберіть Авто
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.title }}
                            </div>
                        </template>
                    </v-select>
                </div>
            
                <trip_modal></trip_modal>
            </div>
        </div>
    
    </div>
</template>

<script>

import vSelect from 'vue-select';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import Trip_modal from "./trip_modal.vue";


export default {
    name: "trip_filter",
    components: {
        Trip_modal,
        vSelect,
        SyncLoader,
    },
    data() {
        return {
            is_load: false,
            
            organizations: [],
            trips_from : [],
            trips_to : [],
            cars : [],
            users: [],
            
            filter : {
                org_id: null,
                trip_from_id : null,
                trip_to_id : null,
                car_id : null,
                user_id: null,
            },
            
        
        }
    },
    created() {
        this.load_filters();
    },
    
    methods: {
        
        emit_filter(param) {
            TRIPCALENDAR.update(this.filter)
        },
        
        async load_filters() {
            this.is_load = true;
            
            this.organizations = [];
            this.users = [];
            this.trips_to = [];
            this.trips_from = [];
            this.cars = [];
            
            
            await api.get('/calendar/trips/filter', {}).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    let resp = data.data;
                    
                    this.set_filter_from_resp(resp,'organizations');
                    this.set_filter_from_resp(resp,'users');
                    this.set_filter_from_resp(resp,'trips_from');
                    this.set_filter_from_resp(resp,'trips_to');
                    this.set_filter_from_resp(resp,'cars');
                    
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        set_filter_from_resp(resp,field) {
            if (resp.hasOwnProperty(field)) {
                resp[field].map(item => {
                    if(this.hasOwnProperty(field)) {
                        this[field].push(item);
                    }
                 
                })
            }
        }
        
       
    }
}
</script>


<style scoped>

</style>